<template>
  <PmSidebarProjectPure
    v-if="purchaseOrder"
    :id="purchaseOrder.id"
    :title="purchaseOrder.caption ?? undefined"
    :alerts-visible="store.state.view.currentView.showMissingResourcesWarning"
    :pill="purchaseOrder.number ?? undefined"
    :update-group-visible="false"
    :jump-visible="true"
    :type="CALENDAR_ITEM_TYPE.PURCHASE_ORDER"
    :is-highlighted="isHighlighted"
    @show-details="showDetails"
    @jump="jumpToPurchaseOrderInCalendar"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

const COMPONENT_NAME = 'PmSidebarPurchaseOrder'

export const propTypes = {} as const

export default defineComponent({
  name: COMPONENT_NAME,
})
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'

import { EVENT } from '@/constants/events'
import { CALENDAR_ITEM_TYPE, DATA_MODAL_TYPE } from '@/constants/persoplan'
import { useCachedQuery } from '@/composition/useCachedQuery'
import { useJumpTargetRegistry } from '@/composition/useJumpTargetRegistry'
import EventHub from '@/eventHub'

import PmSidebarProjectPure from '@/components/persoplan/PmSidebarProject/PmSidebarProjectPure.vue'

import { SidebarPurchaseOrderDocument } from '../../../../generated/graphql'

export interface Props {
  id: number
}

const props = withDefaults(defineProps<Props>(), {})

const store = useStore()
const jumpTargetRegistry = useJumpTargetRegistry()

const purchaseOrderQuery = useCachedQuery(SidebarPurchaseOrderDocument, () => ({
  id: props.id,
}))

const purchaseOrder = computed(
  () => purchaseOrderQuery.result.value?.purchaseOrder
)

function showDetails() {
  EventHub.$emit(EVENT.DATA_MODAL_SHOW, {
    type: DATA_MODAL_TYPE.PURCHASE_ORDER,
    id: props.id,
  })
}

function jumpToPurchaseOrderInCalendar() {
  const jumpTarget = {
    type: CALENDAR_ITEM_TYPE.PURCHASE_ORDER,
    id: props.id,
  } as const

  if (!jumpTargetRegistry.isAvailable(jumpTarget)) {
    throw new Error('jumpTarget is not available')
  }

  jumpTargetRegistry.jumpTo(jumpTarget)
  store.commit('persoplan/clearHighlightedItems')
  isHighlighted.value = true
}

const isHighlighted = computed({
  get: function () {
    return store.getters['persoplan/isItemHighlighted']({
      id: props.id,
      type: CALENDAR_ITEM_TYPE.PURCHASE_ORDER,
    })
  },
  set: function (value) {
    if (value === true) {
      store.commit('persoplan/addToHighlightedItems', {
        id: props.id,
        type: CALENDAR_ITEM_TYPE.PURCHASE_ORDER,
      })
    } else {
      store.commit('persoplan/removeFromHighlightedItems', {
        id: props.id,
        type: CALENDAR_ITEM_TYPE.PURCHASE_ORDER,
      })
    }
  },
})
</script>
